import {
   MedicalDocumentationSendCommand,
   MedicalDocumentationSendingResult,
} from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { ActionEventInterceptor } from '@dreryk/react-components';
import { Range } from '@dreryk/watermelon';

import {
   MedicalDocumentationShareFormBean,
   MedicalDocumentationShareFormController,
} from '~libs.desktop.shared.medical-documentation';

import { medicalDocumentationCreateTranslationKeys } from '../../../../translations';
import {
   MedicalDocumentationCreateFormBean,
   MedicalDocumentationCreateFormController,
} from '../../MedicalDocumentationCreateForm.types';

type MedicalDocumentationSendActionEventInterceptorRenderProps = {
   filePassword: string | null;
};

type MedicalDocumentationSendActionEventInterceptorProps = {
   readonly handleMedicalDocumentationGenerateSubmit: MedicalDocumentationCreateFormController['handleSubmit'];
   readonly handleMedicalDocumentationShareSubmit: MedicalDocumentationShareFormController['handleSubmit'];
   readonly children: (renderProps: MedicalDocumentationSendActionEventInterceptorRenderProps) => JSX.Element;
   readonly patientId: number;
};

export const MedicalDocumentationSendActionEventInterceptor = (
   props: MedicalDocumentationSendActionEventInterceptorProps
): JSX.Element => {
   const { executeAsync: sendMedicalDocumentation, data } = useCqrsCommand<
      MedicalDocumentationSendingResult,
      MedicalDocumentationCreateFormBean & MedicalDocumentationShareFormBean
   >((parameters) => {
      const command = new MedicalDocumentationSendCommand();
      command.patientId = props.patientId;
      command.emailAddress = parameters.emailAddress!;
      command.phoneNumber = parameters.phoneNumber!;
      if (parameters.periodRange === 'SELECTED_RANGE') {
         command.dateRange = Range.closed(parameters.dateFrom!, parameters.dateTo!);
      }
      return command;
   });

   return (
      <ActionEventInterceptor
         // eslint-disable-next-line @typescript-eslint/require-await
         action={props.handleMedicalDocumentationGenerateSubmit(async (medicalDocumentationGenerateParameters) => {
            return props.handleMedicalDocumentationShareSubmit(async (medicalDocumentationShareParameters) => {
               return sendMedicalDocumentation({
                  ...medicalDocumentationGenerateParameters,
                  ...medicalDocumentationShareParameters,
               });
            })();
         })}
         blockingOperation={medicalDocumentationCreateTranslationKeys.sendingDocumentation}
      >
         {props.children({
            filePassword: data?.encryptionPassword ?? null,
         })}
      </ActionEventInterceptor>
   );
};
